import createSagaMiddleware from 'redux-saga';
import { authCookieMiddleware } from './middlewares/authCookieMiddleware';

export const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware, authCookieMiddleware];

/* c8 ignore next 5 */
if (process.env.NODE_ENV === 'development') {
  const devMiddlewares = require('./middlewares-dev').default;

  middlewares.push(...devMiddlewares);
}

export default middlewares;
